<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12">Duration</label>
        <div class="form-group">
            <div class="col-md-6">
                <div class="input-group width-100">
                    <input type="number" min="0" :id="hoursId"  v-model="hours"  class="form-control price-new-inputs" @change="validateInputs">

                    <span class="input-group-addon input-group-addon-new-design"
                          style="background-color: #F5F5F6 !important;">
                <b> hrs </b>
            </span>
                </div>
            </div>
            <div class="col-md-6">
                <div class="input-group width-100">
                    <input type="number" min="0" :id="minuteId"  v-model="minutes" class="form-control price-new-inputs"  @change="validateInputs">
                    <span class="input-group-addon input-group-addon-new-design"
                          style="background-color: #F5F5F6 !important;">
                <b> min </b>
            </span>
                </div>
                <input type="hidden" :name="name"  v-model="quantity_time" class="form-control price-new-inputs">

            </div>
        </div>
        <div v-if="validationMessage" class="text text-danger error-label">{{ validationMessage }}</div>
    </div>

</template>

<script>
import {EventBus} from "@/events/event-bus";

export default {
    name: "ChargeByTimeField",
    data() {
        return {
            hours: 0,
            minutes: 0,
            quantity_time:0,
            actualTime:0,
            validationMessage: ''
        }
    },
    props: {
        unitAttribute: {
            required: true
        },
        service: null,
        quantityAttribute: {
            required: true
        },
        value: {}
    },
    computed: {
        hoursId() {
            if (parseInt(this.service.clone)) {
                return `hours_attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}_${this.service.clone}`;
            }
            if (   this.quantityAttribute && this.quantityAttribute.attribute_id ) {
                return `hours_attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}`;
            }
        },
        minuteId() {
            if (parseInt(this.service.clone)) {
                return `mins_attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}_${this.service.clone}`;
            }
            if ( this.quantityAttribute && this.quantityAttribute.attribute_id ){
                return `mins_attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}`;
            }
        },

        name() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}_${this.service.clone}`;
            }
            if ( this.quantityAttribute && this.quantityAttribute.attribute_id ) {
                return `attribute_${this.service.service_id}${this.quantityAttribute.attribute_id}`;
            }
        }
    },
    methods: {
        setDefaultValue() {
            if ((this.quantityAttribute)) {
                this.convertDecimalToTime()
            }
        },
        validateInputs: function() {
            if (this.hours <= 0 && this.minutes <= 0) {
                this.validationMessage = "Either hours or minutes must be greater than 0!";
                return false;
            } else {
                this.validationMessage = "";
                return true;
            }
        },
        getDurationInHours(unit) {

            let durationInHours = 0;

            switch (unit) {
                case "Min":
                    durationInHours = 1 / 60;
                    break;
                case "15 Min":
                    durationInHours = 1 / 4;
                    break;
                case "30 Min":
                    durationInHours = 1 / 2;
                    break;
                case "Hour(s)":
                case "hour":
                    durationInHours = 1;
                    break;
                case "Day(s)":
                case "day":
                    durationInHours = 24;
                    break;
                case "Week(s)":
                case "week":
                    durationInHours = 24 * 7;
                    break;
                case "Fortnight(s)":
                case "Biweekly":
                    durationInHours = 24 * 15;
                    break;
                case "Month(s)":
                case "Month":
                    durationInHours = 24 * 30;
                    break;
                case "Year(s)":
                case "Year":
                    durationInHours = 24 * 365;
                    break;
            }


            return durationInHours;
        },

        convertTimeToDecimal() {

            if (this.validateInputs()) {
            let total_min = this.parseIntOrDefault(this.hours * 60) + this.parseIntOrDefault(this.minutes);
            let durationInHours =  this.getDurationInHours(this.unitAttribute.default_value);
            this.quantity_time =   total_min / (durationInHours * 60.0);
            this.actualTime =total_min / 60 ;
                this.updateQuantity()
            }
        },
        convertDecimalToTime() {
            let duration_in_hours =this.getDurationInHours(this.unitAttribute.default_value);//.5
            let actual_time = duration_in_hours* this.quantityAttribute.default_value;
            if (this.quantityAttribute.service_attribute_value){
                actual_time = duration_in_hours * this.quantityAttribute.service_attribute_value;//.5*2  = 1
            }
            this.hours  =  this.parseIntOrDefault(actual_time);//.5*2  = 1
            this.minutes =  this.parseIntOrDefault((actual_time * 60) % 60);//1*60
            this.convertTimeToDecimal()
        },
        updateQuantity(){

            EventBus.$emit("updateServicePrice", {
                service: this.service,
                serviceQuantity: this.quantity_time,
                actualTime: this.actualTime
            })
        },
        parseIntOrDefault(value, defaultValue = 0) {
            const result = parseInt(value);
            return isNaN(result) ? defaultValue : result;
        },

    },
    mounted() {
        this.setDefaultValue()
    },
    watch:{
        quantity_time(value) {
            this.$emit('input', +value);
            this.updateQuantity();
        },
        hours(){
            this.convertTimeToDecimal();
        },
        minutes(){
            this.convertTimeToDecimal();
        }

    }
}
</script>

<style scoped>

</style>